"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionDialog = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var react_hotkeys_hook_1 = require("react-hotkeys-hook");
var AlertMessage_1 = require("../../molecules/AlertMessage/AlertMessage");
var BaseDialog_1 = require("../../molecules/BaseDialog/BaseDialog");
var BaseDialogContent_1 = require("../../molecules/BaseDialog/BaseDialogContent/BaseDialogContent");
var BaseDialogHeader_1 = require("../../molecules/BaseDialog/BaseDialogHeader/BaseDialogHeader");
var ActionDialog_static_1 = require("./ActionDialog.static");
var ActionDialog_style_1 = __importDefault(require("./ActionDialog.style"));
/**
 * ActionDialog organism
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/organisms-dialogs-actiondialog--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/organisms/ActionDialog Source}
 */
var ActionDialog = function (_a) {
    var _b = _a.disableConfirm, disableConfirm = _b === void 0 ? false : _b, isLoading = _a.isLoading, onAccept = _a.onAccept, onCancel = _a.onCancel, onExited = _a.onExited, isOpen = _a.isOpen, title = _a.title, children = _a.children, actionText = _a.actionText, error = _a.error, disabledConfirmTooltip = _a.disabledConfirmTooltip, className = _a.className, footerContent = _a.footerContent, minHeight = _a.minHeight, minWidth = _a.minWidth, height = _a.height, width = _a.width, maxWidth = _a.maxWidth, optional = _a.optional, enabledConfirmCancelTooltip = _a.enabledConfirmCancelTooltip, alignCenter = _a.alignCenter;
    var classes = (0, ActionDialog_style_1.default)();
    var _c = __read((0, react_1.useState)(true), 2), isContentAtTop = _c[0], setIsContentAtTop = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isContentAtBottom = _d[0], setIsContentAtBottom = _d[1];
    var handleAccept = (0, react_1.useCallback)(function () { return void onAccept(); }, [onAccept]);
    (0, react_hotkeys_hook_1.useHotkeys)('ctrl+enter, command+enter', handleAccept, {
        enableOnTags: ['INPUT', 'SELECT', 'TEXTAREA'],
        enabled: !disableConfirm && !isLoading && isOpen,
    });
    return ((0, jsx_runtime_1.jsxs)(BaseDialog_1.BaseDialog, __assign({ isOpen: !!isOpen, onClose: onCancel, onExited: onExited, disableEscapeKeyDown: true, disableBackdropClick: true, minHeight: minHeight, minWidth: minWidth, width: width, height: height, maxWidth: maxWidth, alignCenter: alignCenter }, { children: [(0, jsx_runtime_1.jsx)(BaseDialogHeader_1.BaseDialogHeader, { title: title, isContentAtTop: isContentAtTop, isLoading: isLoading, actions: {
                    onCancel: {
                        title: ActionDialog_static_1.localText.cancel,
                        handler: onCancel,
                        isDisabled: isLoading,
                        tooltip: disableConfirm ? undefined : enabledConfirmCancelTooltip,
                    },
                    onAccept: {
                        title: isLoading ? ActionDialog_static_1.localText.pleaseWait : actionText,
                        handler: handleAccept,
                        isDisabled: disableConfirm,
                        disabledTooltip: disabledConfirmTooltip,
                    },
                }, optional: optional }), (0, jsx_runtime_1.jsx)(BaseDialogContent_1.BaseDialogContent, __assign({ isContentAtTop: isContentAtTop, isContentAtBottom: isContentAtBottom, setIsContentAtBottom: setIsContentAtBottom, setIsContentAtTop: setIsContentAtTop, className: (0, classnames_1.default)(classes.content, className), alwaysRenderBottomDivider: false }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.innerContent }, { children: [!isLoading && !!error && ((0, jsx_runtime_1.jsx)(AlertMessage_1.AlertMessage, { className: classes.alert, message: error, title: ActionDialog_static_1.localText.errorOccurred, hasCopyAction: true })), isLoading && (0, jsx_runtime_1.jsx)("div", { className: classes.loadingMask }), children] })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.bottomMask, !footerContent && classes.bottomMaskHeight) }, { children: !!footerContent && footerContent }))] })));
};
exports.ActionDialog = ActionDialog;
